function e(e) {
  return e.toLowerCase();
}
export { e as lowerCase };